import React, { useState } from 'react';
import { TrendingUp, ChevronDown } from 'lucide-react';
import styles from './AnnualTotalCard.module.css';
import { formatCOP, formatUSD } from '../utils/formatters';

interface Props {
    totalAnualUSD: number;
    totalAnualCOP: number;
}

export function AnnualTotalCard({ totalAnualUSD, totalAnualCOP }: Props) {
    const [showUSDAsPrimary, setShowUSDAsPrimary] = useState(true);
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className={styles.factorCard}>
            <div
                className={styles.cardHeader}
                onClick={() => setIsExpanded(!isExpanded)}
                style={{ cursor: 'pointer', marginBottom: isExpanded ? '20px' : '0' }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <TrendingUp size={20} color="#10b981" />
                    <h3 className={styles.cardTitle}>Costo por Año</h3>
                </div>
                <ChevronDown
                    size={20}
                    color="white"
                    style={{
                        marginLeft: 'auto',
                        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease'
                    }}
                />
            </div>

            {isExpanded && (
                <>
                    <div className={styles.factorHeader}>
                        <div className={styles.labelWithTooltip}>
                            <span className={styles.factorLabel}>Costo Total Estimado (1 Año)</span>
                            <div className={styles.tooltipContainer}>
                                <div className={styles.infoIcon}>i</div>
                                <div className={styles.tooltipContent}>
                                    <p>Incluye todos los costos mensuales proyectados, G&A, costos operativos y costos únicos (Hiring, Safety Study, etc).</p>
                                </div>
                            </div>
                        </div>

                        <div
                            className={styles.amountContainer}
                            onClick={() => setShowUSDAsPrimary(!showUSDAsPrimary)}
                            title="Click para cambiar divisa principal"
                        >
                            {/* Primary Value */}
                            <span className={styles.factorValue}>
                                {showUSDAsPrimary ? formatUSD(totalAnualUSD) : formatCOP(totalAnualCOP)}
                                <span className={styles.currencyLabel}>{showUSDAsPrimary ? ' USD' : ' COP'}</span>
                            </span>

                            {/* Secondary Value */}
                            <div className={styles.secondaryValue}>
                                {showUSDAsPrimary ? formatCOP(totalAnualCOP) : formatUSD(totalAnualUSD)}
                                <span>{showUSDAsPrimary ? ' COP' : ' USD'}</span>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
